module.exports = __webpack_public_path__ + "img/_54A6757_t.1aa017e9.jpg";